// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "title-3D8kR";
var _5 = "card-12Llc";
var _6 = "cardWrapper-oOtKz";
var _7 = "miles-1kuFo";
var _8 = "milesStatus__header-22MY3";
var _9 = "milesHistory-JRLyj";
var _a = "milesStatus__value-285vG";
var _b = "progress-21j1i";
var _c = "links-3DMKO";
var _d = "gold-68p2R";
var _e = "silver-27ZSJ";
var _f = "platinum-2S0rE";
var _10 = "miles__left-2wKkU";
var _11 = "miles__total-19m4P";
var _12 = "miles__link-3l5V0";
var _13 = "divider-10dBt";
var _14 = "promo-1kdqw";
var _15 = "promo__title-2PEJK";
var _16 = "vouchers-3EmVo";
var _17 = "milesStatus__miles-3aIlQ";
var _18 = "loyalty__body-d_mPd";
var _19 = "loyalty__paper-1Apys";
var _1a = "loyalty__modal-1fH2q";
var _1b = "loyalty__header-3gR6A";
var _1c = "loyalty__text-3FvyX";
var _1d = "loyalty__footer-67DZU";
var _1e = "loyalty__footerCancel-XBMyH";
var _1f = "pagination-1OiNk";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "title", _5 as "card", _6 as "cardWrapper", _7 as "miles", _8 as "milesStatus__header", _9 as "milesHistory", _a as "milesStatus__value", _b as "progress", _c as "links", _d as "gold", _e as "silver", _f as "platinum", _10 as "miles__left", _11 as "miles__total", _12 as "miles__link", _13 as "divider", _14 as "promo", _15 as "promo__title", _16 as "vouchers", _17 as "milesStatus__miles", _18 as "loyalty__body", _19 as "loyalty__paper", _1a as "loyalty__modal", _1b as "loyalty__header", _1c as "loyalty__text", _1d as "loyalty__footer", _1e as "loyalty__footerCancel", _1f as "pagination" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "title": _4, "card": _5, "cardWrapper": _6, "miles": _7, "milesStatus__header": _8, "milesHistory": _9, "milesStatus__value": _a, "progress": _b, "links": _c, "gold": _d, "silver": _e, "platinum": _f, "miles__left": _10, "miles__total": _11, "miles__link": _12, "divider": _13, "promo": _14, "promo__title": _15, "vouchers": _16, "milesStatus__miles": _17, "loyalty__body": _18, "loyalty__paper": _19, "loyalty__modal": _1a, "loyalty__header": _1b, "loyalty__text": _1c, "loyalty__footer": _1d, "loyalty__footerCancel": _1e, "pagination": _1f }
